import { getMeta } from './helpers';

// Set webpack public asset url
window.__webpack_public_path__ = getMeta('theme-url');

import { Application } from '@hotwired/stimulus';
import SliderController from './controllers/slider-controller';
import AppController from './controllers/app-controller';
import PostsController from './controllers/posts-controller';
import AxiosFormController from './controllers/axios-form-controller';
import LeafletMapsController from './controllers/leaflet-maps-controller';
import CookieBarController from './controllers/cookie-bar-controller';
import ModalController from "./controllers/modal-controller";
import FileController from "./controllers/file-controller";

require('./cursor');
require('./lightbox');

const application = Application.start();

application.register('slider', SliderController);
application.register('app', AppController);
application.register('posts', PostsController);
application.register('axios-form', AxiosFormController);
application.register('map', LeafletMapsController);
application.register('cookie-bar', CookieBarController);
application.register('modal', ModalController);
application.register('file', FileController);
